import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dimmer, Loader, Segment, Form} from 'semantic-ui-react';
import ThreeComponent from './ThreeComponent';
import Model from './Model';

const RACE_KEY = 'model-viewer-race';
const SEX_KEY = 'model-viewer-sex';

export default class ModelViewer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sex: localStorage.getItem(SEX_KEY) || 'female',
            race: localStorage.getItem(RACE_KEY) || 'human',
            isLoading: false,
        };
    }

    componentWillUnmount() {
        localStorage.setItem(RACE_KEY, this.state.race);
        localStorage.setItem(SEX_KEY, this.state.sex)
    }

    render() {
        const {isLoading, race, sex} = this.state;
        const {appearanceId, model, compact, width} = this.props;

        const rotationInfo = model.getRotationalInformation();
        const modelString = `${appearanceId}_${race}_${sex}`;

        const genders = [
            { key: 'm', text: 'Male', value: 'male' },
            { key: 'f', text: 'Female', value: 'female' },
        ];

        const races = [
            { key: 'b', text: 'Bahmi', value: 'bahmi' },
            { key: 'd', text: 'Dwarf', value: 'dwarf' },
            { key: 'e', text: 'Elf', value: 'elf' },
            { key: 'h', text: 'Human', value: 'human' },
        ];

        const sizeStyle= (width) ?
                         {minWidth: width, minHeight: width} :
                         {};

        const raceGenderForm = model.hasRaceAndGenderModels && !compact ?
                                <Segment>
                                    <Form>
                                        <Form.Group widths='equal'>
                                            <Form.Select fluid label='Race' options={races} placeholder='Race' value={race} onChange={ (e, v) => { this.setState({race: v.value});}}/>
                                            <Form.Select fluid label='Gender' options={genders} placeholder='Gender' value={sex} onChange={ (e, v) => { this.setState({sex: v.value});}}/>
                                        </Form.Group>
                                    </Form>
                                </Segment> :
                                null;

        return (
            <div style={sizeStyle}>
                <Segment.Group>
                    <Dimmer active={isLoading}>
                        <Loader>Loading model</Loader>
                    </Dimmer>
                    <Segment>
                        <ThreeComponent model={modelString} padding={28} rotation={rotationInfo} onLoading={(isLoading) => {this.setState({isLoading: isLoading})}} />
                    </Segment>
                    {raceGenderForm}
                </Segment.Group>
            </div>
        )
    }
}

ModelViewer.propTypes = {
    appearanceId: PropTypes.string.isRequired,
    model: PropTypes.instanceOf(Model).isRequired,
    compact: PropTypes.bool,
    width: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/model-viewer/ModelViewer.jsx